import ProjectConfig from 'ProjectConfig';

// Global site tag (gtag.js) - Google Analytics
const gaCode  = ProjectConfig.GA_CODE;

export const googleAnalyticsSrc = `https://www.googletagmanager.com/gtag/js?id=${gaCode}&l=dataLayer`;

// export const googleAnalyticsScript = `
// window.bDataLayer = window.bDataLayer || [];
// function gtag(){bDataLayer.push(arguments);}
// gtag('js', new Date());
// gtag('config', '${gaCode}',{ 'send_page_view': false });
// `;


// Google Tag Manager
const gtmCode  = ProjectConfig.GTM_CODE;

export const googleTagManagerScript = `<!-- Google Tag Manager -->
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${gtmCode}');
<!-- End Google Tag Manager -->`;


// Facebook SDK
const facebookAppId = __CONFIG__.facebookAppId || '442062083149776';
let IS_FB_INIT = false;

export function initFacebookSdk () {
  return new Promise((resolve, reject) => {
    if (!__CONFIG__.crawlersEnabled) return reject();

    if (IS_FB_INIT) return resolve();

    window.fbAsyncInit = function () {
      window?.FB?.init?.({
        appId: facebookAppId,
        xfbml: true,
        version: 'v12.0'
      });
      resolve();
      IS_FB_INIT = true;
      window.FB.AppEvents.logPageView();
    };

    (function (d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s); js.id = id;
      js.src = 'https://connect.facebook.net/en_US/sdk.js';
      
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  });
}


// taboola Pixel
export const taboolaPixelScript = `<!-- Taboola Pixel Code -->
  window._tfa = window._tfa || [];
  window._tfa.push({notify: 'event', name: 'page_view', id: 1340277});
  !function (t, f, a, x) {
          if (!document.getElementById(x)) {
            t.async = 1;t.src = a;t.id=x;f.parentNode.insertBefore(t, f);
          }
  }(document.createElement('script'),
  document.getElementsByTagName('script')[0],
  '//cdn.taboola.com/libtrc/unip/1340277/tfa.js',
  'tb_tfa_script');
<!-- End of Taboola Pixel Code -->`;

// export const adformScript = `
//   window._adftrack = Array.isArray(window._adftrack) ? window._adftrack : (window._adftrack ? [window._adftrack] : []);
//   (function () { var s = document.createElement('script'); s.type = 'text/javascript'; s.async = true; s.src = 'https://s2.adform.net/banners/scripts/st/trackpoint-async.js'; var x = document.getElementsByTagName('script')[0]; x.parentNode.insertBefore(s, x); })();
// `;
